"use strict";
// this was copied from https://raw.githubusercontent.com/theodorejb/es-cookie (MIT License)
// easier to just include as-is than handle rebundling (may revisit in future)
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.set = exports.get = exports.getAll = exports.parse = exports.encode = void 0;
function stringifyAttribute(name, value) {
    if (!value) {
        return '';
    }
    let stringified = '; ' + name;
    if (value === true) {
        return stringified; // boolean attributes shouldn't have a value
    }
    return stringified + '=' + value;
}
function stringifyAttributes(attributes) {
    if (typeof attributes.expires === 'number') {
        let expires = new Date();
        expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e5);
        attributes.expires = expires;
    }
    return (stringifyAttribute('Expires', attributes.expires ? attributes.expires.toUTCString() : '') +
        stringifyAttribute('Domain', attributes.domain) +
        stringifyAttribute('Path', attributes.path) +
        stringifyAttribute('Secure', attributes.secure) +
        stringifyAttribute('SameSite', attributes.sameSite));
}
/** Encode a cookie value to be set in the browser document.cookie collection. */
function encode(name, value, attributes) {
    return (encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent) // allowed special characters
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29') + // replace opening and closing parens
        '=' +
        encodeURIComponent(value)
            // allowed special characters
            .replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent) +
        stringifyAttributes(attributes));
}
exports.encode = encode;
/**
 * Parse cookie string containing one or more raw cookie values into dictionary of key/value pairs.
 *
 * @param cookieString - string of cookies to parse (e.g. document.cookie)
 */
function parse(cookieString) {
    let result = {};
    const cookies = cookieString ? cookieString.split('; ') : [];
    for (let cookie of cookies) {
        const parts = cookie.split('=');
        let value = parts.slice(1).join('=');
        if (value[0] === '"') {
            value = value.slice(1, -1);
        }
        try {
            const name = decodeURIComponent(parts[0]);
            result[name] = value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        }
        catch (e) {
            // ignore cookies with invalid name/value encoding
        }
    }
    return result;
}
exports.parse = parse;
/** Parse and return all cookies in the browser as name-value pairs. */
function getAll() {
    return parse(document.cookie);
}
exports.getAll = getAll;
/** Get the value of a single cookie by name. */
function get(name) {
    return getAll()[name];
}
exports.get = get;
/** Set a cookie value in the browser document.cookie collection. */
function set(name, value, attributes) {
    document.cookie = encode(name, value, Object.assign({ path: '/' }, attributes));
}
exports.set = set;
/** Remove a cookie from the browser document.cookie collection. */
function remove(name, attributes) {
    set(name, '', Object.assign(Object.assign({}, attributes), { expires: -1 }));
}
exports.remove = remove;
